/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description':
    'Požádejte tým nebo správce o podporu.',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title':
    'Načtení výsledků tohoto vyhledávání se nezdařilo',
};
